import { Stack } from "@mui/material";
import { Match} from "../directus/collections/match.type";
import { OrderTypeLabel } from "../directus/collections/order.type";

export function MatchInfoDataList({ match }: { match: Match }) {
  console.log("match", match);
  return (
    <Stack spacing={2}>
      <dl>
        <Stack direction={"row"} spacing={2}>
          <dt>Id match</dt>
          <dd>
            <a
              href={`https://admin.garipalli.com/admin/content/matches/${match.id}`}
              target="_blank"
            >
              {match.id}
            </a>
          </dd>
        </Stack>
        <Stack direction={"row"} spacing={2}>
          <dt>Nome team</dt>
          <dd>{match?.team_name || "N/D"}</dd>
        </Stack>
        <Stack direction={"row"} spacing={2}>
          <dt>Tipologia</dt>
          <dd>
            {match?.order_type ? OrderTypeLabel[match?.order_type] : "N/D"}
          </dd>
        </Stack>
        {match?.order_type == "s" && (
          <Stack direction={"row"} spacing={2}>
            <dt>Ordine</dt>
            <dd>
              <a
                href={`https://garipalli.com/admin/orders/${match?.order_id
                  .split("_")
                  .shift()}`}
                target="_blank"
              >
                {match?.shopify_order || "N/D"}
              </a>
            </dd>
          </Stack>
        )}
        <Stack direction={"row"} spacing={2}>
          <dt>Acquistato il</dt>
          <dd>
            {!match?.purchased_at
              ? "N/D"
              : new Date(match?.purchased_at).toLocaleString()}
          </dd>
        </Stack>
        <Stack direction={"row"} spacing={2}>
          <dt>Avviato il</dt>
          <dd>
            {!match?.date_created
              ? "N/D"
              : new Date(match?.date_created).toLocaleString()}
          </dd>
        </Stack>
        <Stack direction={"row"} spacing={2}>
          <dt>Terminato il</dt>
          <dd>
            {!match?.completed_at
              ? "N/D"
              : new Date(match?.completed_at).toLocaleString()}
          </dd>
        </Stack>
        <Stack direction={"row"} spacing={2}>
          <dt>Proprietario</dt>
          <dd>{match?.owner?.email || "N/D"}</dd>
        </Stack>
      </dl>
    </Stack>
  );
}
